export function getAdParam(paramName: 'gclid' | 'gbraid' | 'wbraid'): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
}

export function storeAdParamInLocalStorage(paramName: 'gclid' | 'gbraid' | 'wbraid', value: string): void {
    localStorage.setItem(paramName, value);
}

export function getStoredAdParam(paramName: 'gclid' | 'gbraid' | 'wbraid'): string | undefined {
    return localStorage.getItem(paramName) || undefined;
}
